import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DirectivesModule } from '../directives.module';
import { CustomControlsModule } from './modules/custom-controls/custom-controls.module';
import { CustomModalsModule } from './modules/custom-modals/custom-modals.module';
import { CustomTableModule } from './modules/custom-table/custom-tables.module';
import { ModalConfigurationStoreService } from './services/modal-configuration-store.service';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    CustomControlsModule,
    CustomTableModule,
    CustomModalsModule,
  ],
  providers: [
    ModalConfigurationStoreService
  ],
})
export class CoreModule { }
